export default "__VITE_ASSET__CLgTKBvj__"